const a = "Đang tải…", n = {
  loading: a
};
export {
  n as default,
  a as loading
};
